import { useStores } from "@stores";
import { BN } from "@utils/BN";
import { formatPercent } from "@utils/Format";
import { observer } from "mobx-react-lite";
import { PercentBadge, PercentText } from "./styles";

interface MarketItemPercentProps {
  marketAddress: string;
}

// Dynamic percent display component - only re-renders when percent changes
export const MarketItemPercent = observer(({ marketAddress }: MarketItemPercentProps) => {
  const { marketStore } = useStores();

  const market = marketStore.allMarkets.find((m) => m.addr === marketAddress);
  if (!market) return null;

  const marketData = marketStore.getMarketData(market.addr);
  const change24h = new BN(marketData?.change24h || 0);
  const isPositive = change24h.gt(BN.ZERO);
  const percentColor = isPositive ? "green-strong" : "red-strong";

  return (
    <PercentBadge data-testid={`favorite-markets:item:${market.addr}:change`} negative={!isPositive} neutral={false}>
      <PercentText data-testid={`favorite-markets:item:${market.addr}:change-text`} color={percentColor}>
        {isPositive && "+"}
        {formatPercent(change24h)}
      </PercentText>
    </PercentBadge>
  );
});
